export const DEFAULT_PAGE = 1;

export const PAGE_SIZE = 10;
export const CACHE_TIME_MS = 5 * 60 * 1000;
export const STALE_TIME_MS = 5 * 60 * 1000;
export const REFETCH_INTERVAL_MS = 5 * 60 * 1000;

export const EIGHTY_VH_RATIO = 0.8;
export const FILTER_TABS_HEIGHT = 48;
export const SEARCH_INPUT_HEIGHT = 48;
export const DEFAULT_ITEM_HEIGHT = 55;

export const INFINITE_LOADER_THRESHOLD = 5;
export const INFINITE_LOADER_MINIMUM_BATCH_SIZE = 10;
export const LIST_OVERSCAN_COUNT = 5;
export const LIST_WIDTH = '100%';
